module.exports = __webpack_public_path__ + "img/DE03949.ad5beadd.png";